export default {
  methods: {
    isBeforeEventDate: function (eventDate) {
      return new Date(eventDate).getTime() > new Date().getTime()
    }
  }
}
